module.exports = __webpack_public_path__ + "static/media/mark-6.jpeg";